import { render } from "./test01.vue?vue&type=template&id=c12bcc40"
import script from "./test01.vue?vue&type=script&lang=js"
export * from "./test01.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__